import React from "react";
import BagckgroundSummary from "./BagckgroundSummary";
import Work from "./Work";
import Certificate from "./Certificate";
import Project from "./Project";
import ExtraCur from "./ExtraCur";
import Publication from "./Publication";

function Background({ className, data }) {
  return (
    <>
      <div className={`${className}`}>
        <div className="">
          {data.educationData.length > 0 && (
            <BagckgroundSummary data={data.educationData} />
          )}
          {/* {data.workData.length > 0 && <Work data={data.workData}/>} */}
          {/* {data.certificatedata.length > 0 && <Certificate data={data.certificatedata}/>} */}
          {/* {data.projectdata.length > 0 && <Project data={data.projectdata}/>} */}
          {/* {data.extraCurdata.length > 0 && <ExtraCur data={data.extraCurdata}/>} */}
          {/* {data.publicationdata.length > 0 && <Publication data={data.publicationdata}/>} */}
        </div>
      </div>
    </>
  );
}

export default Background;
